import { Component, OnInit } from '@angular/core';
import { RefundListModalComponent } from '@lib/shared';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({ standalone: false, selector: 'app-refund-modal', templateUrl: './refund.component.html' })
export class CustomRefundListModalComponent extends RefundListModalComponent implements OnInit {
  constructor(protected bsModalRef: BsModalRef) {
    super(bsModalRef);
  }
}
